// Стабильные ключи статусов разбора жалобы (совпадают с backend ComplaintCaseStatuses).
export const STATUS_ORDER = ['new', 'in_review', 'resolved', 'not_complaint'];

export const STATUS_LABELS = {
  new: 'Новая',
  in_review: 'В разборе',
  resolved: 'Разобрана',
  not_complaint: 'Не жалоба'
};

export const STATUS_BADGE_CLASSES = {
  new: 'bg-red-100 text-red-800 hover:bg-red-100',
  in_review: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
  resolved: 'bg-emerald-100 text-emerald-800 hover:bg-emerald-100',
  not_complaint: 'bg-slate-100 text-slate-600 hover:bg-slate-100'
};
